import React, { useState } from 'react';
import ModeratorHeader from './ModeratorHeader';
import ModeratorSidebar from './ModeratorSidebar';
import Mailbox from '../../../components/Mailbox/Mailbox';
import PublicChat from '../../../components/PublicChat/PublicChat';
import ModeratorsTable from '../../features/ModeratorsTable';
import ClientsTable from '../../features/ClientsTable';
import AlumniTable from '../../features/AlumniTable';
import ApplicationsTable from '../../features/ApplicationsTable';
import AdminReports from '../../features/AdminReports';
import Announcement from '../../../components/Announcement/Announcement';
import ModeratorCRM from '../../../components/crm/ModeratorCRM';
import IntroToCostingAndManAcc from '../../../components/training/IntroToCostingAndManAcc';
import DesignABusiness from '../../../components/training/DesignABusiness';
import ProgramHealthCheckDashboard from '../../../components/Programs/ProgramHealthCheckDashboard';
import GrantBasics from '../../../components/Funding/GrantBasics';
import ApplicationTutorials from '../../../components/Funding/ApplicationTutorials';
import LogoutConfirmation from '../../../components/ui/LogoutConfirmation';
import { useAuth } from '../../../context/AuthContext';
import ScalingModules from '../../../components/Modules/ScalingModules';
import ModeratorReports from '../../features/ModeratorReports';
import CapacityBuildingProgram from '../../../components/training/CapacityBuildingProgram';
import ProfilingAnalyticsDashboard from '../../../components/ProfilingForms/ProfilingAnalyticsDashboard';
import HealthDashboard from '../../../components/HealthCheck/HealthDashboard';
import ClientDocumentBrowser from '../../../components/DocumentBank/ClientDocumentBrowser';
import Commercialisation from '../../../components/Commercialisation/Commercialisation';
import CommercialisationReadinessChecklist from '../../../components/Commercialisation/CommercialisationReadinessChecklist';
import GTMStrategyPlan from '../../../components/Commercialisation/GTMStrategyPlan';
import StartupLaunchChecklist from '../../../components/Commercialisation/StartupLaunchChecklist';
import AdminAnalyticsDashboard from '../../../components/Commercialisation/AdminAnalyticsDashboard';
import AdminPanel from '../../../components/Commercialisation/AdminPanel';
import SettingsPageComponent from '../../main/SettingsPage';
import ProductDevelopment from '../../../components/ProductDevelopment/ProductDevelopment';
import JunkDashboard from '../../../components/SharedFeature/JunkDashboard';
import MonthlyCoachingReport from '../../../components/Reports/MonthlyCoachingReport';

const ModeratorTraining = () => {
  const [activeCourse, setActiveCourse] = useState('business');
  const [userRole] = useState('moderator');

  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h1 className="mb-2 text-3xl font-bold text-black">Training Oversight</h1>
          <p className="text-gray-600">
            Monitor training programs, configure settings, and export reports
          </p>
        </div>

        <div className="mb-8 rounded-lg border border-gray-200 bg-white shadow-sm">
          <div className="border-b border-gray-200">
            <nav className="flex space-x-8 px-6">
              <button
                onClick={() => setActiveCourse('business')}
                className={`flex items-center gap-2 border-b-2 px-1 py-4 text-sm font-medium transition-colors ${
                  activeCourse === 'business'
                    ? 'border-blue-600 text-black'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-black'
                }`}
              >
                <span>Design-A-Business</span>
              </button>
              <button
                onClick={() => setActiveCourse('costing')}
                className={`flex items-center gap-2 border-b-2 px-1 py-4 text-sm font-medium transition-colors ${
                  activeCourse === 'costing'
                    ? 'border-blue-600 text-black'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-black'
                }`}
              >
                <span>Introduction to Costing & Management Accounting</span>
              </button>
              <button
                onClick={() => setActiveCourse('capacity')}
                className={`flex items-center gap-2 border-b-2 px-1 py-4 text-sm font-medium transition-colors ${
                  activeCourse === 'capacity'
                    ? 'border-blue-600 text-black'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-black'
                }`}
              >
                <span>Capacity Building Program</span>
              </button>
            </nav>
          </div>

          <div className="p-6">
            {activeCourse === 'business' && <DesignABusiness userRole={userRole} />}
            {activeCourse === 'costing' && <IntroToCostingAndManAcc userRole={userRole} />}
            {activeCourse === 'capacity' && <CapacityBuildingProgram userRole={userRole} />}
          </div>
        </div>
      </div>
    </div>
  );
};

const sectionPlaceholders = {
  dashboard: <ModeratorCRM />,
  training: <ModeratorTraining />,
  'product-development': <ProductDevelopment userRole="moderator" />,
  'program-health-check': <ProgramHealthCheckDashboard userRole="moderator" />,

  'business-health': (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-lg md:p-8">
      <HealthDashboard userRole="moderator" />
    </div>
  ),
  funding: (
    <div className="mx-auto max-w-5xl space-y-8 p-4">
      <GrantBasics userRole="moderator" />
      <ApplicationTutorials userRole="moderator" />
    </div>
  ),
  scalingmodules: <ScalingModules userRole="moderator" />,
  commercialisation: <Commercialisation userRole="moderator" />,
  'commercialisation-readiness-checklist': (
    <CommercialisationReadinessChecklist userRole="moderator" />
  ),
  'go-to-market-strategy': <GTMStrategyPlan userRole="moderator" />,
  'startup-launch-checklist': <StartupLaunchChecklist userRole="moderator" />,
  'commercialisation-admin-panel': <AdminPanel />,
  'commercialisation-analytics': <AdminAnalyticsDashboard />,
  crm: <ModeratorCRM />,
  settings: <SettingsPageComponent />,
  moderators: <ModeratorsTable />,
  clients: <ClientsTable />,
  alumni: <AlumniTable />,
  applications: <ApplicationsTable />,
  reports: <AdminReports />,
  announcement: <Announcement />,
  'weekly-reports': <ModeratorReports />,
  'monthly-coaching-reports': <MonthlyCoachingReport userRole="moderator" />,
  'profiling-analytics': <ProfilingAnalyticsDashboard userRole="moderator" />,
  'document-bank': (
    <ClientDocumentBrowser
      title="Client Document Bank"
      description="Search for a client to review and collaborate on their documents instantly."
    />
  ),
  'junk-management': <JunkDashboard />,
};

const ModeratorDashboard = ({ user }) => {
  const { logout } = useAuth();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [selectedSection, setSelectedSection] = useState('dashboard');
  const [inboxSubsection, setInboxSubsection] = useState('public');
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const renderContent = () => {
    if (selectedSection === 'communication') {
      return inboxSubsection === 'public' ? <PublicChat /> : <Mailbox />;
    }
    if (selectedSection === 'announcements') {
      return <Announcement />;
    }

    return sectionPlaceholders[selectedSection] || sectionPlaceholders.dashboard;
  };

  const confirmLogout = async () => {
    setShowLogoutConfirm(false);
    await logout();
  };

  return (
    <div className="flex h-screen bg-white">
      <ModeratorSidebar
        collapsed={sidebarCollapsed}
        setCollapsed={setSidebarCollapsed}
        selected={selectedSection}
        setSelected={setSelectedSection}
        inboxSubsection={inboxSubsection}
        onInboxSubsectionChange={setInboxSubsection}
        user={user}
      />
      <div className="flex min-w-0 flex-1 flex-col">
        <ModeratorHeader user={user} />
        <main className="flex-1 overflow-y-auto bg-white">{renderContent()}</main>
      </div>
      <LogoutConfirmation
        isOpen={showLogoutConfirm}
        onConfirm={confirmLogout}
        onCancel={() => setShowLogoutConfirm(false)}
      />
    </div>
  );
};

export default ModeratorDashboard;
